module.exports = "/_next/static/images/caravanalt-14f92d83b716f0a6bc78a9640261034c.svg";